// Native
import { useState } from "react"
import { useNavigate, useParams } from "react-router"

// Components
import { Box, Center, HStack, ModalBody, Spinner, Text } from "@chakra-ui/react"
import { Modal, Pressable, Profile, Searchable, Tag } from "components"

// Hooks
import { useConsultant, useConsultantNetworkSearch } from "hooks"

export default function Search({ ...props }){

    const params = useParams()
    const consultant = useConsultant(params?.id)
    const [ term, setTerm ] = useState()
    const search = useConsultantNetworkSearch(params?.id, term)

    // console.log("SEARCH", search)

    return(
    <Modal title="Buscar consultor na rede" {...props}>
        <ModalBody>
            <Text fontSize="sm">
                Aqui você pode verificar se algum consultor faz parte da rede de <b>{consultant.data?.customer?.name}</b>.
            </Text>

            <Searchable placeholder="Pesquisar pelo nome do consultor..." setValue={setTerm} isDisabled={search.isFetching} />

            <Box p={4}>
                { !!search.isFetching ? <Center><Spinner /></Center> : search.data?.map(item => <Item key={item.consultant_id} data={item} />) }
            </Box>
        </ModalBody>
    </Modal>
    )
}

const Item = ({ data }) => {

    const navigate = useNavigate()

    return(
    <Pressable onClick={() => navigate(`/consultants/${data.consultant_id}`)}>
        <Box p={3} borderBottomWidth={1}>
            <HStack>
                <Profile name={data.name} />
                <Tag size="sm" children={`${data.level}º nível`} />
            </HStack>
        </Box>
    </Pressable>
    )
}